/**
 * The only two ways the FTP changes (SPEC §7.5 as amended): entered once at the first start, and
 * afterwards automatically by a completed FTP test. There is deliberately no free "edit FTP" path.
 */
import { getSettings, useSettings } from './settings';
import { isValidFtp, needsFtp } from './settingsModel';

/** First-start FTP. Ignored once an FTP has been set (by onboarding or a test). */
export async function setInitialFtp(ftp: number, riderWeightKg?: number): Promise<boolean> {
  if (!needsFtp(getSettings()) || !isValidFtp(ftp)) return false;
  const patch: Parameters<ReturnType<typeof useSettings.getState>['update']>[0] = {
    ftp: Math.round(ftp),
    ftpSetAt: Date.now(),
    ftpSource: 'onboarding',
  };
  if (riderWeightKg !== undefined && riderWeightKg >= 30 && riderWeightKg <= 200)
    patch.riderWeightKg = riderWeightKg;
  await useSettings.getState().update(patch);
  return true;
}

/** Result of a completed FTP test. Returns the previous FTP. */
export async function applyTestedFtp(ftp: number): Promise<number> {
  const previous = getSettings().ftp;
  if (!isValidFtp(ftp)) return previous;
  await useSettings.getState().update({ ftp: Math.round(ftp), ftpSetAt: Date.now(), ftpSource: 'test' });
  return previous;
}
